import { useEffect, useState } from "react";
import { LoggedInAppArgs } from './App';
import { Link, useNavigate, useOutletContext } from 'react-router-dom';
import { GetScapesResponse, ScapeShallow } from "./Data/Response";
import styles from './ScapeList.module.scss';
import ScapeCreateModalView from "./ScapeCreateModalView";
import { CreateRequest, CreateResponse, OnScapeAddedRequest, OnScapeMembersUpdatedRequest, OnScapeRoomUpdatedRequest, PaginatedResponse, SignalRResponse, ListScapesRequest, ScapeOrderBy, SortDirectionEnum } from "./Data/ScapeData";

const ScapeList: React.FC = () => {
    const args = useOutletContext() as LoggedInAppArgs;
    const nav = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [scapes, setScapes] = useState<ScapeShallow[] | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const onScapeAddedHandler = async (result: OnScapeAddedRequest) => {
        console.log("Scape added");
        console.log(result);
        if (!args.scapeConnection) {
            console.log("Failed to find scape connection");
            return;
        }
        try {
            const shallowScapeResponse: SignalRResponse<ScapeShallow> = await args.scapeConnection.invoke("GetShallow", { Id: result.scapeId });
            console.log("Shallow scape returned");
            console.log(shallowScapeResponse);
            setScapes(prev => [shallowScapeResponse.data, ...prev]
            );
        } catch (e) {
            console.log("Failed to get shallow scape from server.");
            console.log(e);
        }
    }

    useEffect(() => {
        if (!args.scapeConnection) {
            return;
        }
        args.scapeConnection.on("OnRoomUpdated", (result: OnScapeRoomUpdatedRequest) => {
            console.log("Scape is live status has been updated.");
            setScapes(prev => prev.map(s => {
                if (s.id !== result.scapeId) {
                    return s;
                }
                const updated: ScapeShallow = {
                    ...s,
                    currentPhotonRoom: result.room
                }
                return updated;
            }))
            console.log(result);
        });

        args.scapeConnection.on("OnScapeAdded", (result: OnScapeMembersUpdatedRequest) => {
            onScapeAddedHandler(result)
                .then(r => {
                    console.log("Success");
                }).catch(e => {
                    console.log("error");
                    console.log(e);
                })
        });

        args.scapeConnection.on("OnMembersUpdated", (result: OnScapeMembersUpdatedRequest) => {
            console.log("Scape Members Updated");
            setScapes(prev => prev.map(s => {
                if (s.id !== result.scapeId) {
                    return s;
                }
                var currentGame = s.currentGame;
                if (
                    s.currentGame &&
                    result.gamePlayers[s.currentGame.id]
                ) {
                    currentGame = {
                        ...s.currentGame,
                        players: result.gamePlayers[s.currentGame.id]
                    }
                }
                const updated: ScapeShallow = {
                    ...s,
                    members: result.members,
                    currentGame: currentGame
                }
                return updated;
            }))
            console.log(result);
        });
        getScapesSignalR();
    }, [args.scapeConnection]);

    const getScapesREST = async (): Promise<GetScapesResponse> => {
        setIsLoading(true);
        const params = new URLSearchParams({
            limit: "20",
            page: "1",
            sortBy: "startTime",
            sortDirection: "desc"
        });
        const token = await args.loggedInUser.getAccessToken();

        const response = await fetch(`/api/v1.0/scapes?${params.toString()}`, {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}` // if using JWT auth
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`);
        }
        setIsLoading(false);
        return await response.json(); // return parsed data
    }

    const getScapesSignalR = async () => {
        if (!args.scapeConnection) {
            console.log("missing scape connection");
            return;
        }
        console.log("Getting scape list.");
        setIsLoading(true);
        args.setModalContent(null);
        try {
            const request: ListScapesRequest = {
                // Page: 1,
                // Limit: 100,
                // OrderBy: ScapeOrderBy.name,
                // SortDirection: SortDirectionEnum.asc
            };
            const temp: SignalRResponse<PaginatedResponse<ScapeShallow>> = await args.scapeConnection.invoke('List', request);
            console.log(`Got scapes`);
            console.log(temp);
            setScapes(temp.data.items);
        } catch (e) {
            const err = e as Error;
            console.log(e);
        }
        setIsLoading(false);
        return;
    }

    const createScapeSignalR = async (name: string, description: string): Promise<string> => {
        if (!args.scapeConnection) {
            console.log("missing scape connection");
            return;
        }
        console.log("Creating a Scape.");
        setIsLoading(true);
        args.setModalContent(null);
        try {
            var req: CreateRequest = {
                Name: name,
                Description: description,
                Game: {
                    RulesetId: "ffnw"
                }
            };
            const temp: SignalRResponse<CreateResponse> = await args.scapeConnection.invoke('Create', req);
            console.log(`Created Scape`);
            console.log(temp);
            nav(`/scape/${temp.data.id}`);
            setIsLoading(false);
            return temp.data.id
        } catch (e) {
            const err = e as Error;
            console.log(e);
            setIsLoading(false);
            throw e;
        }
    }

    const createScapeREST = async (name: string, description: string, isBot: boolean) => {
        if (isLoading) {
            return;
        }
        setIsLoading(true);
        const token = await args.loggedInUser.getAccessToken();
        const response = await fetch(`/api/v1.0/scapes`, {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`, // if using JWT auth
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                Name: name,
                Description: description,
                Game: {
                    RulesetId: "ffnw"
                }
                //         IsBot: isBot
            })
        });
        if (!response.ok) {
            setErrorMessage("Error");
        }
        else {
            const result = await response.json();
            args.setModalContent(null);
            nav(`/scape/${result.id}`);
        }
        setIsLoading(false);
        // return await response.json(); // return parsed data
    }

    if (isLoading) {
        return <div>Loading Scapes...</div>
    }

    if (scapes) {
        return <div>
            <h1>Scapes</h1>
            <button
                onClick={e => {
                    args.setModalContent({
                        element: <ScapeCreateModalView createHandler={createScapeSignalR} isLoading={isLoading} />,
                        canClose: true
                    })
                }}
            >Create New Scape</button>
            <ul>
                {scapes.map(s => {
                    if (s.currentGame) {
                        return <li><Link className={`${s.currentPhotonRoom ? styles.isLive : ""} ${styles.scape}`} to={`scape/${s.id}`}>
                            <p>{s.id} : {s.name}</p>
                            <p>game Id : {s.currentGame?.id}</p>
                            {s.currentPhotonRoom && <p>
                                Members Online: {s.currentPhotonRoom.totalUserCount}
                            </p>}
                            {s.currentPhotonRoom && <p>
                                Players Online: {s.currentPhotonRoom.playerCount}
                            </p>}
                            <h3>Players:</h3>
                            <ul className={styles.playerList}>
                                {s.currentGame.players.map(p => {
                                    return <li>
                                        <img src={p.avatar.smallUrl} />
                                        <p>{p.username}</p>
                                    </li>
                                })}
                            </ul>
                        </Link></li>
                    }
                    return <li className={styles.scape}>
                        {s.id} : {s.name}
                    </li>
                })}
            </ul>
        </div>
    }

    return <div>Error getting scapes: {errorMessage}</div>
};


export default ScapeList;